import { removeVoucherRequest } from '@app/ducks';
import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button } from '../Button';
import { Remove } from '../Icons';

interface Props {
  id: string;
  name: string;
  value: React.ReactNode;
  isReadOnly: boolean;
}

export const OrderTotalsSummaryVoucherItem = ({ name, value, isReadOnly, id }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['checkout']);

  const handleRemoveVoucher = React.useCallback(() => {
    dispatch(removeVoucherRequest(id));
  }, [dispatch, id]);

  return (
    <div className={cx('flex justify-between py-3 first:pt-0')}>
      <dt className="text-neutral-40">{name}:</dt>
      <dd className="flex items-center text-neutral-20">
        <span>{value}</span>
        {!isReadOnly && (
          <Button
            color="danger"
            variant="text"
            icon={Remove}
            aria-label={t('checkout:voucher_remove')}
            onClick={handleRemoveVoucher}
            size="medium"
          />
        )}
      </dd>
    </div>
  );
};
